import React, { useEffect, useState } from "react";

// SERVICES
import DeliveryRadiusService from "../../api/deliveryRadius";
// APP
import RemoveModal from "../modals/removeModal";
import CreateOrEditDeliveryRadiusModal from "../deliveryRadius/createOrEditDeliveryRadiusModal";
// MATERIAL UI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { ButtonNoShadow } from "../styled/button";
// ICONS
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { LightGreyBox } from "../styled";
import { grey } from "@mui/material/colors";
import { formatFinance, formatKm } from "../../utils/formatters";

const DeliveryRadiusList = () => {
  const [loading, setLoading] = useState(false);
  const [deliveryRadius, setDeliveryRadius] = useState([]);
  const [editingDeliveryRadius, setEditingDeliveryRadius] = useState(null);
  const [showDeliveryRadiusModal, setDeliveryRadiusModal] = useState(false);

  const [deliveryRadiusToDelete, setDeliveryRadiusToDelete] = useState(null);
  const [showDeliveryRadiusDeleteModal, setShowDeliveryRadiusDeleteModal] =
    useState(false);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setTimeout(async () => {
      await loadDeliveryRadius();
    }, 10);
  }, []);

  const loadDeliveryRadius = async () => {
    setLoading(true);
    const res = await DeliveryRadiusService.getDeliveryRadius();
    setDeliveryRadius(res.data);
    setLoading(false);
  };

  const handleDeliveryRadiusModal = () => {
    setDeliveryRadiusModal(!showDeliveryRadiusModal);
    setEditingDeliveryRadius(null);
  };

  const createDeliveryRadius = async (deliveryRadiusObj) => {
    try {
      await DeliveryRadiusService.createDeliveryRadius(deliveryRadiusObj);

      handleDeliveryRadiusModal();
      await loadDeliveryRadius();
    } catch (e) {
      const errorData = e.response.data;
      let messages = "";
      for (const prop in errorData) {
        if (errorData.hasOwnProperty(prop)) {
          messages += errorData[prop].join("\n") + "\n";
        }
      }

      setErrorMessage(messages);
      setOpenErrorAlert(true);
    }
  };

  const handleEditDeliveryRadius = (deliveryRadius) => {
    setEditingDeliveryRadius(deliveryRadius);
    setDeliveryRadiusModal(!showDeliveryRadiusModal);
  };

  const editDeliveryRadius = async (deliveryRadiusObj) => {
    try {
      await DeliveryRadiusService.editDeliveryRadius(
        deliveryRadiusObj,
        deliveryRadiusObj.id
      );

      handleDeliveryRadiusModal();
      setEditingDeliveryRadius(null);
      await loadDeliveryRadius();
    } catch (e) {
      const errorData = e.response.data;
      let messages = "";
      for (const prop in errorData) {
        if (errorData.hasOwnProperty(prop)) {
          messages += errorData[prop].join("\n") + "\n";
        }
      }

      setErrorMessage(messages);
      setOpenErrorAlert(true);
    }
  };

  const handleDeleteDeliveryRadiusModal = (deliveryRadius) => {
    setDeliveryRadiusToDelete(deliveryRadius);
    setShowDeliveryRadiusDeleteModal(!showDeliveryRadiusDeleteModal);
  };

  const handleDeleteDeliveryRadius = async () => {
    await DeliveryRadiusService.deleteDeliveryRadius(deliveryRadiusToDelete.id);
    setShowDeliveryRadiusDeleteModal(false);
    setDeliveryRadiusToDelete(null);
    await loadDeliveryRadius();
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Box display="flex" justifyContent="center">
          <ButtonNoShadow
            variant="contained"
            startIcon={<AddCircleIcon />}
            onClick={handleDeliveryRadiusModal}
            sx={{ mb: 1, boxShadow: 0 }}
          >
            Novo Raio de Entrega
          </ButtonNoShadow>
        </Box>
      </Box>
      <Box sx={{ p: 2 }}>
        <LightGreyBox>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2" fontWeight="bold">
              De (km)
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              Até (km)
            </Typography>
            <Typography variant="body2" fontWeight="bold" align="center">
              Valor
            </Typography>
            <Typography variant="body2" fontWeight="bold" align="center">
              Valor Entregador
            </Typography>
            <Typography variant="body2" fontWeight="bold" align="center">
              Opções
            </Typography>
          </Stack>
          {deliveryRadius.map((deliveryRadiusItem) => {
            return (
              <Stack
                key={deliveryRadiusItem.id}
                direction="row"
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="body2">
                  {formatKm(deliveryRadiusItem.from_distance)} Km
                </Typography>
                <Typography variant="body2">
                  {formatKm(deliveryRadiusItem.to_distance)} Km
                </Typography>
                {deliveryRadiusItem.delivery_tax && (
                  <Typography variant="body2" align="center">
                    {formatFinance(parseFloat(deliveryRadiusItem.delivery_tax))}
                  </Typography>
                )}

                {!deliveryRadiusItem.delivery_tax && (
                  <Typography
                    variant="body2"
                    align="center"
                    sx={{ color: grey[300] }}
                  >
                    Nada
                  </Typography>
                )}
                <Typography variant="body2" align="center">
                  {formatFinance(
                    parseFloat(deliveryRadiusItem.delivery_guy_tax)
                  )}
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="space-between"
                >
                  <IconButton
                    size="small"
                    aria-label="edit"
                    title="Editar"
                    onClick={() => handleEditDeliveryRadius(deliveryRadiusItem)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    size="small"
                    aria-label="delete"
                    color="error"
                    title="Deletar"
                    onClick={() =>
                      handleDeleteDeliveryRadiusModal(deliveryRadiusItem)
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              </Stack>
            );
          })}
        </LightGreyBox>
      </Box>

      <RemoveModal
        title="Deletar Raio de Entrega"
        message={`Deseja deletar o raio de entrega ${formatKm(
          deliveryRadiusToDelete?.from_distance
        )}km - ${formatKm(deliveryRadiusToDelete?.to_distance)}km?`}
        show={showDeliveryRadiusDeleteModal}
        toggleModal={handleDeleteDeliveryRadiusModal}
        onRemove={handleDeleteDeliveryRadius}
      />

      {showDeliveryRadiusModal && (
        <CreateOrEditDeliveryRadiusModal
          show={showDeliveryRadiusModal}
          closeModal={handleDeliveryRadiusModal}
          createDeliveryRadius={createDeliveryRadius}
          editDeliveryRadius={editDeliveryRadius}
          deliveryRadius={editingDeliveryRadius}
        />
      )}
    </>
  );
};
export default DeliveryRadiusList;
